// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module--card--1FeRw","title":"styles-module--title--2piZS","icon":"styles-module--icon--1g4gW","description":"styles-module--description--4jOwC"};